import { render, staticRenderFns } from "./TopRightMenu.vue?vue&type=template&id=56692f7a&"
import script from "./TopRightMenu.vue?vue&type=script&lang=js&"
export * from "./TopRightMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports